import { TextareaHTMLAttributes, forwardRef } from 'react';

interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  hint?: string;
}

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(function Textarea(
  { label, hint, className = '', ...rest },
  ref
) {
  return (
    <label className="block w-full">
      {label && <span className="mb-1.5 block text-sm font-medium text-ink-700">{label}</span>}
      <textarea
        ref={ref}
        rows={3}
        className={[
          'w-full rounded-xl border border-ink-200 bg-surface px-4 py-3 text-[15px] text-ink-800',
          'placeholder:text-ink-400 transition-colors duration-200 resize-none',
          'focus:outline-none focus:ring-2 focus:ring-brand-200 focus:border-brand-400',
          className,
        ].join(' ')}
        {...rest}
      />
      {hint && <span className="mt-1 block text-xs text-ink-400">{hint}</span>}
    </label>
  );
});
